<template>
    <div>
        <a-table :columns="columns" :data-source="data" :loading="loading" rowKey="id" :pagination="false">
            <span slot="action" slot-scope="text, record">
             <i v-if="$_hasAll(['btn_edit'])" style="color:#838383">暂无操作权限</i>
        <a @click="(record)=>{visibleForm = true; titleForm='管理广告图'; editId=text.id ; }" v-has="'btn_edit'">管理广告图</a>
      </span>
        </a-table>
        <AdvertisingForm :visible="visibleForm" :title="titleForm" :editId="editId"
                         @changVisible=" () => { this.visibleForm = false;this.editId='';  this.getList()}  "/>
    </div>

</template>

<script>
    import API from "./api";
    import AdvertisingForm from "./components/advertisingForm"

    const columns = [
        {
            title: "页面",
            dataIndex: "name",
            width: "15%",
            ellipsis: true,
            key: "name"
        },
        {
            title: "图片数量",
            dataIndex: "count",
            width: "15%",
            ellipsis: true,
            key: "count"
        },
        {
            title: "操作",
            key: "action",
            width: "200px",
            scopedSlots: {customRender: "action"}
        }
    ];
    export default {
        name: 'AdvertisingManagement',
        data() {
            return {
                visibleForm: false,
                hasAllShow:false,
                titleForm: "",
                loading: true,
                editId: null,
                jurisdictionId: null,
                visibleJurisdiction: false,
                data: [],
                columns,
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/SiteSettings/AdvertisingManagement"; //设置左侧导航2-2 active


        },
        components: {AdvertisingForm},
        methods: {
            getList() {
                API.advertisingManagement.GET_LIST().then(res => {
                    this.data = res.data.data
                    // this.hasAllShow =this.$_hasAll(['btn_edit'])
                    this.loading = false
                })
            },
        },
        mounted() {
            this.getList()

        }

    }
</script>
